import { render, staticRenderFns } from "./ProfileMilestones.vue?vue&type=template&id=4485ca96&scoped=true"
import script from "./ProfileMilestones.vue?vue&type=script&lang=js"
export * from "./ProfileMilestones.vue?vue&type=script&lang=js"
import style0 from "./ProfileMilestones.vue?vue&type=style&index=0&id=4485ca96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4485ca96",
  null
  
)

export default component.exports